module.exports = __webpack_public_path__ + "static/content-requests-mobile-4aee24335ca5bba06140f7cacd0af866.png";